
import { createClient } from '@supabase/supabase-js';

// Safe environment variable accessor
const getEnv = (key: string): string | undefined => {
  // @ts-ignore
  if (typeof import.meta !== 'undefined' && import.meta.env) return import.meta.env[key];
  // @ts-ignore
  if (typeof process !== 'undefined' && process.env) return process.env[key];
  return undefined;
};

const supabaseUrl = getEnv('VITE_SUPABASE_URL');
const supabaseKey = getEnv('VITE_SUPABASE_ANON_KEY');

const placeholderUrl = 'https://placeholder.supabase.co';

export const isSupabaseConfigured = !!supabaseUrl && 
                                    !!supabaseKey && 
                                    supabaseUrl !== 'undefined' && 
                                    supabaseUrl !== placeholderUrl;

// Use placeholders to allow app initialization; requests will fail gracefully if unconfigured.
const url = supabaseUrl || placeholderUrl;
const key = supabaseKey || 'placeholder';

export const supabase = createClient(url, key);
